import { getServices } from '~/db/services';
import { createCategoryFromAssessment } from '~/lib/assessment';

export const useCategoryGetParamsAssessmentRun =
  async (): Promise<UseCategoryGetParams> => {
    const route = useRoute();

    let baseCategory: CategorySchema;

    const slug = ref<string>();

    const { mainContent: originContent } = useContents();

    const section = ref<Sections>(Sections.ChildForYou);

    const assesments = useAssessmentsStore();

    const uuid = route.params.lb_or_eval as string;

    const assessment = assesments.getAssessment(uuid);

    slug.value = route.params.category as string;

    if (!slug.value) {
      baseCategory = createCategoryFromAssessment(assessment);
    }

    const currentContent = computed(() => {
      let path = `/${Sections.ChildForYou}`;
      path = uuid ? `${path}/${uuid}` : path;
      return {
        ...originContent.value,
        path,
        slug: uuid,
      };
    });

    return {
      currentContent,
      section,
      slug,
      isStudyContent: false,
      baseCategory,
      isHome: false,
    };
  };
